import { CarModelIdentifier, ModelIdentifier } from '~/graphql/__generated__/graphql';

/** Creates a `code|extensions|year|version` string to simplify trimline related data aggregation. */
export function getModelIdString(id: CarModelIdentifier | undefined | null) {
	if (!id) {
		return '';
	}

	return `${id.code}|${id.extensions && id.extensions.length ? `${id.extensions.join('-')}|` : ''}${id.year}|${
		id.version
	}`;
}

export function getModelIdStringFromPr7Extension(id: ModelIdentifier | undefined | null) {
	if (!id) {
		return '';
	}

	return `${id.code}|${id.extensionsPR7 && id.extensionsPR7.length ? `${id.extensionsPR7.join('-')}|` : ''}${id.year}|${
		id.version
	}`;
}
